import { ActionReducerMap } from '@ngrx/store';

import { AuthState } from './reducers/auth.reducer';
import { OrderState } from './reducers/order.reducer';
import { RewardState } from './reducers/reward.reducer';
import { RolesState } from './reducers/index';
import { StoreState } from './reducers/stores.reducer';
import { SupplierState } from './reducers/supplier.reducer';
import { LabelState } from './reducers/label.reducer';
import { UserState } from './reducers/user.reducer';
import * as reducers from './reducers/index';

export interface AppState {
  auth: AuthState;
  users: UserState;
  roles: RolesState;
  rewards: RewardState;
  stores: StoreState;
  suppliers: SupplierState;
  labels: LabelState;
  orders: OrderState;
}

export const appReducers: ActionReducerMap<AppState> = {
  auth: reducers.AuthReducer,
  users: reducers.UserReducer,
  roles: reducers.RolesReducer,
  rewards: reducers.RewardsReducer,
  stores: reducers.StoresReducer,
  suppliers: reducers.SuppliersReducer,
  labels: reducers.LabelsReducer,
  orders: reducers.OrdersReducer
};
